import { Box } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { SpacerSdk } from "~/core";

export type SpacerProps = {
  data: SpacerSdk;
};

export const Spacer: FC<SpacerProps> = ({ data }) => {
  const mobileSpace = data.mobile_vertical_space ?? 0;
  const tabletSpace = data.tablet_vertical_space ?? mobileSpace;
  const desktopSpace = data.desktop_vertical_space ?? tabletSpace;
  return (
    <Box
      m={{ mt: mobileSpace }}
      md={{ m: { mt: tabletSpace } }}
      d={{ m: { mt: desktopSpace } }}
    />
  );
};
